/*
 *
 * SupportPanel
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from './types';
import BigOptionButton from 'components/BigOptionButton';
import SectionOptions from 'components/SectionOptions';
import {
  restoreCabinet,
  setDrawersRequest,
} from 'containers/Configurator/actions/furniture';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import styled from 'styled-components/macro';
import {
  makeSelectLastHistoryCabinet,
  makeSelectShelvesSelectedLastHistory,
} from 'containers/Configurator/selectors/history';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { makeSelectCommonHeight } from 'containers/Ribbon/ShelvesRibbon/selectors';
import { DRAWERS_COMPOSITION } from 'containers/DrawersCompositionPanel/constants';
import { useTranslation } from 'react-i18next';
import { getFilename } from 'containers/DrawersCompositionPanel/utils';

interface StateProps {
  cabinet: Cabinet;
  shelves: Shelf[];
  commonHeight: number | undefined;
}

interface Props {
  hideOptionsFunction?: any;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  cabinet: makeSelectLastHistoryCabinet(),
  shelves: makeSelectShelvesSelectedLastHistory(),
  commonHeight: makeSelectCommonHeight(),
});

const DrawersOptions = ({ hideOptionsFunction }: Props) => {
  const dispatch = useDispatch();
  const { cabinet, shelves, commonHeight } = useSelector(stateSelector);
  const selectedCombo = shelves[0].getDrawersCombo();
  const { t } = useTranslation();

  function onLeave() {
    dispatch(restoreCabinet(cabinet));
  }

  function isSelectedCombo(combo: number[]) {
    if (selectedCombo) {
      return (
        selectedCombo.every(e => combo.includes(e)) &&
        combo.every(e => selectedCombo.includes(e))
      );
    }
    return false;
  }

  let compositionsDrawersList = undefined;
  if (commonHeight && DRAWERS_COMPOSITION[commonHeight]) {
    compositionsDrawersList = DRAWERS_COMPOSITION[commonHeight];
  } else {
    compositionsDrawersList = [[commonHeight]];
  }

  if (!commonHeight) {
    return (
      <div>
        <div className="bg-gray-200 border py-1 px-2 text-main italic font-semibold">
          {t(
            'To modify the drawers composition, all the selected shelves should have the same height.',
          )}
        </div>
      </div>
    );
  }

  return (
    <StyledSupportOptions>
      <SectionOptions diviser={false}>
        {commonHeight &&
          compositionsDrawersList.map((combo: number[]) => (
            <BigOptionButton
              key={`${combo}`}
              imgSrc={getFilename(combo)}
              title={`[${combo}]`}
              handleClick={() => {
                dispatch(setDrawersRequest(combo, false));
                if (hideOptionsFunction) hideOptionsFunction(false);
              }}
              handleHover={() => {
                dispatch(setDrawersRequest(combo, true));
              }}
              onLeave={onLeave}
              selected={isSelectedCombo(combo)}
              rectangle={true}
              className="xl:mx-2"
            />
          ))}
      </SectionOptions>
    </StyledSupportOptions>
  );
};

export default DrawersOptions;

const StyledSupportOptions = styled.div`
  //mx-4 flex justify-center
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  justify-content: center;

  @media (min-width: 478px) {
    margin: 0 0.5rem;
  }

  @media (min-width: 1024px) {
    margin: 0;
  }

  @media (min-width: 1280px) {
    margin: 0 0.5rem;
  }
`;
